<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <h2 class="rounded text-center bg-warning text-dark">View Group Session</h2>
            <table class="table table-active">
                <tbody class="">
                <p>Centre Details</p>
                <tr>
                    <th>Child Name</th>
                    <td>{{getchildNames(data.children)}}</td>
                </tr>
                <tr>
                    <th>Centre Name</th>
                    <td>{{getCenterNames(data.centres)}}</td>
                </tr>
                <tr>
                    <th>Target Group</th>
                    <td>{{data.participants}}</td>
                </tr>

                <br>
<!--                <p>Description</p>-->
<!--                <tr>-->
<!--                    <th>Description</th>-->
<!--                    <td>{{data.description}}</td>-->
<!--                </tr>-->
                <br>
                <p>Session Details</p>
                <tr>
                    <th>Session Date</th>
                    <td>{{(getDate(data.date))}}</td>
                </tr>
                <tr>
                    <th>Start Time</th>
                    <td>{{getTime(data.startTime)}}</td>
                </tr>

                <tr>
                    <th>End Time</th>
                    <td>{{getTime(data.endTime)}}</td>
                </tr>

<!--                <tr>-->
<!--                    <th>Highlight of Session</th>-->
<!--                    <td>{{data?.highlight}}</td>-->
<!--                </tr>-->
                <tr>
                    <th>Session topic</th>
                    <td>{{getTopicsCovered(data.topicsCovered)}}</td>
                </tr>
                <tr>
                  <th>Issue</th>
                  <td>{{data.issue}}</td>
                </tr>
                <br>
                <p></p>
                <tr>
                  <th>Intervention</th>
                  <td>{{data?.intervention}}</td>
                </tr>

                <tr>
                    <th>Takeaway</th>
                    <td>{{data?.takeaway}}</td>
                </tr>


                </tbody>

            </table>
        </div>
        <div class="col-md-12">
            <h2 class="rounded  text-center bg-warning text-dark">Documents & Uploads</h2>
            <!--            <h3>Data will be uploaded to {{mStoragePath}} in {{mDbType}} at {{mPath}} </h3>-->
          <div class="col-md-6">
          <app-file-upload [storagePath]="mStoragePath" [dbPath]="mPath" fileCount="multi"></app-file-upload>
          </div>  <!--            <app-upload [dbType]="mDbType" [path]="mPath" [storagePath]="mStoragePath" ></app-upload>-->
        </div>
      <div>
      <h3>Uploaded Documents</h3>
      <!--                  <prettyjson [obj]="data"></prettyjson>-->
      <!--         COPY-->
        <div class="cdk-virtual-scroll-data-source-example">
          <cdk-virtual-scroll-viewport orientation="horizontal" itemSize="5" class="example-viewport">
            <div class="d-flex  flex-row">
              <div *cdkVirtualFor="let d of (mDocuments);trackBy:trackByMethod;let i = index" class="example-item ">
                <a (click)="openLink(d.url)">
                  <img [src]="d.url" style="width: 250px; height: 250px" class="img-thumbnail img-fluid">
                </a>
                <p style="flex-grow: 9; font-size: 14px" class="text-center">{{d.description}}</p>
                <button mat-icon-button color="warn" (click)="deleteAdmissionFile(i,d,'documents')">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          </cdk-virtual-scroll-viewport>
        </div>
      </div>
        <!--COPY-->


    </div>

</div>


<!--<prettyjson [obj]="documents$|async"></prettyjson>-->
